export default function LogoMark({ size = 34, color = "#184167", className = "" }) {
  return (
    <svg
      data-testid="logo-mark"
      width={size}
      height={size}
      viewBox="0 0 48 48"
      fill="none"
      className={className}
      aria-hidden="true"
    >
      <path
        d="M6 36 L16 12 L24 30 L32 10 L42 36"
        stroke={color}
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
